import { render, staticRenderFns } from "./NarrowLoader.vue?vue&type=template&id=21c1852e&"
import script from "./NarrowLoader.vue?vue&type=script&lang=js&"
export * from "./NarrowLoader.vue?vue&type=script&lang=js&"
import style0 from "./NarrowLoader.vue?vue&type=style&index=0&id=21c1852e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports